import { createRouter, createWebHistory } from "vue-router";
import Home           from "./views/Home.vue";
import Search         from "./views/Search.vue";
import ActivityDetail from "./views/ActivityDetail.vue";
import Login          from "./views/Login.vue";
import Profile        from "./views/Profile.vue";
import CreateActivity from "./views/CreateActivity.vue";
import RegistrationManagement from "./views/RegistrationManagement.vue";
import ActivityApproval from "./views/ActivityApproval.vue";
import MyActivities from "./views/MyActivities.vue";
import EssaySubmission from "./views/EssaySubmission.vue";
import SSOSuccess from "./views/SSOSuccess.vue";

const routes = [
  { 
    path: "/",            
    name: "Home",
    component: Home 
  },
  {
  path: '/sso-success',
  name: 'SSOSuccess',
  component: () => import('./views/SSOSuccess.vue'),
  meta: { 
    title: 'SSO 登入',
    requiresAuth: false  // 不需要驗證，因為這是登入流程的一部分
  }
  },
  { 
    path: "/search",      
    name: "Search",
    component: Search 
  },
  {
    path: "/activity/:id",
    name: "ActivityDetail",
    component: ActivityDetail,
    props: true,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: "/my-activities",
    name: "MyActivities", 
    component: MyActivities,
    meta: { requiresAuth: true },
  },
  {
    path: "/essay-submission",
    name: "EssaySubmission",
    component: EssaySubmission,
    meta: { requiresAuth: true },
  },
  {
    path: "/create-activity",
    name: "CreateActivity",
    component: CreateActivity,
    meta: { 
      requiresAuth: true,
      // 所有登入使用者都可以進入（student 可以申請，dept/admin 可以直接創建）
    },
  },
  {
    path: "/registration-management",
    name: "RegistrationManagement",
    component: RegistrationManagement,
    meta: { 
      requiresAuth: true,
      requiresRole: ['dept', 'admin'] // 只有 dept 和 admin 可以進入
    },
  },
  {
    path: "/activity-approval",
    name: "ActivityApproval",
    component: ActivityApproval,
    meta: { 
      requiresAuth: true,
      requiresRole: ['dept', 'admin'] // 只有 dept 和 admin 可以進入
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 全域前置 guard：檢查權限
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem("access_token");
  
  // 檢查是否需要登入驗證
  if (to.meta.requiresAuth && !token) {
    console.log('需要登入，跳轉到登入頁');
    return next({ name: "Login" });
  }
  
  // 檢查角色權限
  if (to.meta.requiresRole) {
    if (!token) {
      console.log('需要權限但未登入，跳轉到登入頁');
      return next({ name: "Login" });
    }
    
    // 嘗試從 localStorage 取得使用者資訊
    let userInfo = null;
    try {
      const userInfoStr = localStorage.getItem('user_info');
      if (userInfoStr) {
        userInfo = JSON.parse(userInfoStr);
      }
    } catch (e) {
      console.error('解析 user_info 失敗:', e);
    }
    
    // 如果沒有使用者資訊，嘗試從 API 取得
    if (!userInfo || !userInfo.role) {
      try {
        // 動態 import API 函數避免循環依賴
        const { getProfile } = await import('./api.js');
        const response = await getProfile();
        userInfo = response.data;
        // 更新 localStorage
        localStorage.setItem('user_info', JSON.stringify(userInfo));
      } catch (error) {
        console.error('取得使用者資訊失敗:', error);
        // 清除無效的 token
        localStorage.removeItem('access_token');
        localStorage.removeItem('token_type');
        localStorage.removeItem('user_info');
        return next({ name: "Login" });
      }
    }
    
    const userRole = userInfo.role;
    const isAuthorized = userInfo.is_authorized === 1 || userInfo.is_authorized === '1';
    console.log('檢查權限 - 使用者角色:', userRole, '需要角色:', to.meta.requiresRole, 'is_authorized:', isAuthorized);

    // 角色符合 或 is_authorized=1 (部門授權) 都可以存取管理頁面
    if (!to.meta.requiresRole.includes(userRole) && !isAuthorized) {
      console.log('權限不足，返回首頁');
      alert('您沒有權限訪問此頁面');
      return next('/');
    }
  }
  
  // 如果已登入用戶訪問登入頁，直接跳轉到首頁
  if (to.name === 'Login' && token) {
    return next('/');
  }
  
  next();
});

export default router;